import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const placeholderAction = createAction(addNamespace('util/placeholder'));
